import { WidgetType } from 'types/widget.types';

export const REVERSE_AXIS_CHARTS = [WidgetType.BarChart];
